import { render, staticRenderFns } from "./Mywealth.vue?vue&type=template&id=11b60b68&scoped=true&"
import script from "./Mywealth.vue?vue&type=script&lang=js&"
export * from "./Mywealth.vue?vue&type=script&lang=js&"
import style0 from "./Mywealth.vue?vue&type=style&index=0&id=11b60b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b60b68",
  null
  
)

export default component.exports